import { MAudioItem } from "./audio";

export class AudioManager {
    public audios: MAudioItem[];
    constructor() {
        this.audios = [];
    }

    add(audio: MAudioItem) {
        this.audios.push(audio);
    }

    public get(id: string): MAudioItem
    public get(): MAudioItem[]
    get(id?: string)  {
        if (id) return this.audios.find((item: MAudioItem) => item.id == id);
        return this.audios;
    }

    remove(id: string) {
        let audio: any = this.get(id)
        if(audio) {
            audio.destroy()
        }
        this.audios = this.audios.filter(a => a.id !== id);
    }

    pause() {
        this.audios.forEach(audio => {
            audio.pause();
        });
    }

    clear() {
        this.audios = [];
    }
}
